import api from "../api/axios";

export const getAllLeaves = async (id, options = "") => {
  try {
    const response = await api.get(`leaveApplications/${id}${options}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching Leaves:", error);
    throw error;
  }
}; 

export const checkAllowanceForAbsent = async (
  employeeId,
  start_date,
  end_date
) => {
  const missingFields = ["employeeId", "start_date", "end_date"].filter(
    (field) => !{ employeeId, start_date, end_date }[field]
  );

  if (missingFields.length) {
    throw new Error(`Missing required fields: ${missingFields.join(", ")}`);
  }
  try {
    const response = await api.get(
      `employee-absences/check-allowance/${employeeId}/${start_date}/${end_date}`
    );
    return response.data;
  } catch (error) {
    console.error("Error checking leave allowance:", error);
    throw error;
  }
};

export const getAllowedLeaves = async (employeeId) => {
  if (!employeeId) {
    throw new Error("Employee ID is required");
  }
  try {
    const response = await api.get(
      `employee-absences/allowed-leave/${employeeId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching allowed leaves:", error);
    throw error;
  }
};
